import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

export const createDefaultTableElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'table',
    tableData: {
      headers: ['Header 1', 'Header 2', 'Header 3'],
      rows: [
        ['Row 1 Col 1', 'Row 1 Col 2', 'Row 1 Col 3'],
        ['Row 2 Col 1', 'Row 2 Col 2', 'Row 2 Col 3'],
        ['Row 3 Col 1', 'Row 3 Col 2', 'Row 3 Col 3'],
      ],
    },
    tableConfig: {
      hasHeader: true,
      stripedRows: true,
      bordered: true,
      responsive: true,
    },
    styles: {
      width: '100%',
      margin: '10px 0',
      fontFamily: 'inherit',
      fontSize: '14px',
      border: '1px solid #e5e7eb',
    },
    _isNew: true,
    _needsSync: true,
  };
};


